import { render } from "./MyBookingInfo.vue?vue&type=template&id=734b4c0c&scoped=true&lang=pug"
import script from "./MyBookingInfo.vue?vue&type=script&lang=ts"
export * from "./MyBookingInfo.vue?vue&type=script&lang=ts"

import "./MyBookingInfo.vue?vue&type=style&index=0&id=734b4c0c&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-734b4c0c"

export default script